// Automatic registration of global components
import {t} from '@/lang'

export default {
    installCom(app) {
        const ctx = require.context('../components', true, /\.vue$/)
		if(ctx && ctx.keys()) {
			ctx.keys()?.forEach(item => {
				const component = ctx(item).default
				let path = (item || component.__file)?.split('/')
				const componentName = path && path.length && path[path.length-1].split('.')[0]
				app.component(componentName, component)
			})
		}
    }
}